export function renderTicket({ ticket, loading, error }) {
  if (loading) {
    return `<div class="wrap"><div class="panel"><p class="muted">Cargando…</p></div></div>`
  }
  if (error) {
    return `
      <div class="wrap">
        <div class="panel">
          <h1>No disponible</h1>
          <p class="msg msg--err">${error}</p>
          <a class="btn btn--ghost" data-link href="/consultar">Consultar con número y email</a>
        </div>
      </div>
    `
  }
  const comments = (ticket.comments || [])
    .map(
      (c) => `
      <article class="comment">
        <p class="comment-meta">${c.author_name || 'Soporte'} · ${formatDate(c.created_at)}</p>
        <p>${escapeHtml(c.body || '')}</p>
      </article>
    `,
    )
    .join('')

  return `
    <div class="wrap">
      <div class="panel">
        <h1>${escapeHtml(ticket.ticket_number || 'Ticket')}</h1>
        <p class="muted">${escapeHtml(ticket.subject || '')}</p>
        <p><span class="badge">${escapeHtml(ticket.status || '')}</span></p>
        <h2 class="h2">Tu mensaje</h2>
        <p>${escapeHtml(ticket.description || '')}</p>
        ${comments ? `<h2 class="h2">Respuestas</h2>${comments}` : '<p class="muted">Aún no hay respuestas públicas.</p>'}
        <div class="btn-row" style="margin-top:1rem;">
          <a class="btn btn--ghost" data-link href="/">Nueva incidencia</a>
        </div>
      </div>
    </div>
  `
}

export async function bindTicket({ token }) {
  const { fetchGuestTicket } = await import('../api.js')
  try {
    const data = await fetchGuestTicket(token)
    return { ticket: data.ticket, error: null }
  } catch (e) {
    return { ticket: null, error: e.message || 'Enlace no válido.' }
  }
}

function formatDate(iso) {
  if (!iso) return ''
  try {
    return new Date(iso).toLocaleString('es-ES')
  } catch {
    return iso
  }
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
